import {
    GET_ALL_QUALIFICATIONS,
    SET_QUALIFICATION_TO_SELECTED,
    SET_QUALIFICATION_TO_DESELECTED,
    SET_SNACKBAR_STATE,
    SET_QUAL_AVAILABLE_TABLE_PAGE,
    SET_QUAL_SELECTED_TABLE_PAGE,
    SET_QUAL_AVAILABLE_TABLE_ROW,
    SET_QUAL_SELECTED_TABLE_ROW,
    SET_QUAL_EDIT_MODAL_INFO,
    POST_QUAL_EDIT_INFO,
    GET_QUALIFICATION_CATEGORIES,
    SET_QUALS_AVAILABLE_SELECTED_CATEGORY,
    SET_ADD_MODAL_INFO,
    GET_ALL_USERS,
    GET_LIST_OF_REQUIRED_QUALIFICATIONS,
    POST_UPDATED_USERS,
    SET_DELETE_MODAL_INFO,
    DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS,
    DELETE_QUALIFICATION_FROM_USERS,
    SET_QUALS_SELECTED_CATEGORY
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    posting: false,
    qualifications: false,
    postSuccess: false,
    postFail: false,
    qualSelectedTablePage: 0,
    qualAvailableTablePage: 0,
    qualAvailableTableRow: 50,
    qualSelectedTableRow: 50,
    qualEditModalInfo: {
        qualInfo: {
            qualID: "",
            qualTitle: false,
            qualExpReq: false,
            qualImgReq: false,
            qualRegReq: false,
            qualVerReq: false
        },
        modalOpen: false
    },
    qualAddModalInfo: {
        qualInfo: {
            qualID: "",
            qualTitle: false,
            qualExpReq: false,
            qualImgReq: false,
            qualRegReq: false,
            qualVerReq: false
        },
        modalOpen: false
    },
    qualCategories: [],
    qualsSelectedSelectedCategory: "all_categories",
    qualsAvailableSelectedCategory: "all_categories",
    allUsers: false,
    requiredQualifications: {},
    deleteModalInfo: {
        qualTitle: "",
        qualID: "",
        modalOpen: false
    },
    deletingQualifications: false
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ALL_QUALIFICATIONS.FAIL: {
            return { ...state, requesting: false, qualifications: false };
        }
        case GET_ALL_QUALIFICATIONS.REQUEST: {
            return { ...state, requesting: true, qualifications: false };
        }
        case GET_ALL_QUALIFICATIONS.SUCCESS: {
            return { ...state, requesting: false, qualifications: action.payload };
        }
        case SET_QUALIFICATION_TO_SELECTED.REQUEST: {
            return { ...state, posting: true, requesting: true, postSuccess: false, postFail: false };
        }
        case SET_QUALIFICATION_TO_SELECTED.FAIL: {
            return { ...state, posting: false, requesting: false, postSuccess: false, postFail: true };
        }
        case SET_QUALIFICATION_TO_SELECTED.SUCCESS: {
            return { ...state, posting: false, requesting: false, postSuccess: true, postFail: false };
        }
        case SET_QUALIFICATION_TO_DESELECTED.REQUEST: {
            return { ...state, posting: true, requesting: true, postSuccess: false, postFail: false };
        }
        case SET_QUALIFICATION_TO_DESELECTED.FAIL: {
            return { ...state, posting: false, requesting: false, postSuccess: false, postFail: true };
        }
        case SET_QUALIFICATION_TO_DESELECTED.SUCCESS: {
            return { ...state, posting: false, requesting: false, postSuccess: true, postFail: false };
        }
        case SET_SNACKBAR_STATE: {
            return { ...state, postSuccess: action.payload, postFail: action.payload };
        }
        case SET_QUAL_SELECTED_TABLE_PAGE: {
            return { ...state, qualSelectedTablePage: action.payload };
        }
        case SET_QUAL_AVAILABLE_TABLE_PAGE: {
            return { ...state, qualAvailableTablePage: action.payload };
        }
        case SET_QUAL_AVAILABLE_TABLE_ROW: {
            return { ...state, qualAvailableTableRow: action.payload };
        }
        case SET_QUAL_SELECTED_TABLE_ROW: {
            return { ...state, qualSelectedTableRow: action.payload };
        }
        case SET_QUAL_EDIT_MODAL_INFO: {
            return { ...state, qualEditModalInfo: action.payload };
        }
        case POST_QUAL_EDIT_INFO.FAIL: {
            return { ...state, postFail: true, postSuccess: false, requesting: false };
        }
        case POST_QUAL_EDIT_INFO.REQUEST: {
            return { ...state, postFail: false, postSuccess: false, requesting: true };
        }
        case POST_QUAL_EDIT_INFO.SUCCESS: {
            return { ...state, postFail: false, postSuccess: true, requesting: true };
        }
        case GET_QUALIFICATION_CATEGORIES.REQUEST: {
            return { ...state, requesting: true, qualCategories: [] };
        }
        case GET_QUALIFICATION_CATEGORIES.FAIL: {
            return { ...state, requesting: false, qualCategories: [] };
        }
        case GET_QUALIFICATION_CATEGORIES.SUCCESS: {
            return { ...state, requesting: false, qualCategories: action.payload };
        }
        case SET_QUALS_AVAILABLE_SELECTED_CATEGORY: {
            return { ...state, qualsAvailableSelectedCategory: action.payload };
        }
        case SET_QUALS_SELECTED_CATEGORY: {
            return { ...state, qualsSelectedSelectedCategory: action.payload };
        }
        case SET_ADD_MODAL_INFO: {
            return { ...state, qualAddModalInfo: action.payload };
        }
        case GET_ALL_USERS.REQUEST: {
            return { ...state, requesting: true, allUsers: false };
        }
        case GET_ALL_USERS.FAIL: {
            return { ...state, requesting: false, allUsers: false };
        }
        case GET_ALL_USERS.SUCCESS: {
            return { ...state, requesting: false, allUsers: action.payload };
        }
        case GET_LIST_OF_REQUIRED_QUALIFICATIONS.REQUEST: {
            return { ...state, requesting: true, requiredQualifications: {} };
        }
        case GET_LIST_OF_REQUIRED_QUALIFICATIONS.FAIL: {
            return { ...state, requesting: false, requiredQualifications: {} };
        }
        case GET_LIST_OF_REQUIRED_QUALIFICATIONS.SUCCESS: {
            return { ...state, requesting: false, requiredQualifications: action.payload };
        }
        case POST_UPDATED_USERS.REQUEST: {
            return { ...state, requesting: true, postSuccess: false, postFail: false };
        }
        case POST_UPDATED_USERS.FAIL: {
            return { ...state, requesting: false, postSuccess: false, postFail: true };
        }
        case POST_UPDATED_USERS.SUCCESS: {
            return { ...state, requesting: false, postSuccess: true, postFail: false };
        }
        case SET_DELETE_MODAL_INFO: {
            return { ...state, deleteModalInfo: action.payload };
        }
        case DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.REQUEST: {
            return { ...state, posting: true, requesting: true, postFail: false, postSuccess: false };
        }
        case DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.FAIL: {
            return { ...state, posting: false, requesting: false, postFail: true, postSuccess: true };
        }
        case DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.SUCCESS: {
            return { ...state, posting: false, requesting: false, postFail: false, postSuccess: true };
        }
        case DELETE_QUALIFICATION_FROM_USERS.REQUEST: {
            return { ...state, deletingQualifications: true, requesting: true, postFail: false, postSuccess: false };
        }
        case DELETE_QUALIFICATION_FROM_USERS.FAIL: {
            return { ...state, deletingQualifications: false, postFail: true, requesting: false, postSuccess: true };
        }
        case DELETE_QUALIFICATION_FROM_USERS.SUCCESS: {
            return { ...state, deletingQualifications: false, postFail: false, requesting: false, postSuccess: true };
        }
        default: {
            return state;
        }
    }
};
